import { Button, Grid, Stack, Typography } from '@mui/material';
import PremiumTextIcon from 'assets/images/dashboard/premium_diamond_text.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { SET_MODAL_STATUS, SET_MODAL_TYPE } from 'store/actions';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
export const QuestionRegistryFremiumListing = ({ type, image, title, subTitle, buttonName, buttonPosition }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { companyCreator } = useSelector((state) => state.authentication);
    const mtByType = type === 'starred' ? 6 : 11;
    return (
        <>
            <Stack
                gap={4}
                className="premium-question-card"
                alignItems="center"
                justifyContent="center"
                sx={{
                    flexDirection: { xs: 'column', md: 'row' },
                    width: '100%'
                }}
                columnGap={4}
                my={3}
            >
                <Stack gap="36px" alignItems="flex-start" width={{ xs: '100%', md: '60%' }}>
                    <Stack gap={2} alignItems="flex-start">
                        <Typography
                            component="span"
                            sx={{
                                display: 'flex',
                                fontSize: '0.875rem',
                                backgroundColor: 'rgba(0, 33, 77, 0.20)',
                                gap: '8px',
                                padding: '8px',
                                borderRadius: '50px',
                                color: '#00214D',
                                alignItems: 'center',
                                svg: {
                                    width: '16px',
                                    height: '16px',
                                    path: {
                                        fill: '#00214D'
                                    }
                                }
                            }}
                        >
                            <DiamondOutlinedIcon />
                            Premium
                        </Typography>
                        <Typography component="h3" color="#212121" fontSize="1.5rem" lineHeight="1.3334" fontWeight="600">
                            {title}
                        </Typography>
                        <Typography variant="subtitle1" component="p" color="#7D7D82" fontSize="1rem" lineHeight="1.2" fontWeight="500">
                            {subTitle}
                        </Typography>
                    </Stack>
                    <Button
                        className="alternate white"
                        variant="contained"
                        onClick={() => {
                            if (!companyCreator) {
                                dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
                                dispatch({ type: SET_MODAL_TYPE, modalType: 'non_permit_upgrade' });
                                return;
                            }
                            navigate('/dashboard/update-plan');
                        }}
                    >
                        {buttonName}
                    </Button>
                </Stack>
                {image && (
                    <Stack width={{ xs: '100%', md: '40%' }}>
                        <img src={image} alt="upgrade-premium-star" />
                    </Stack>
                )}
            </Stack>
        </>
    );
};
export default QuestionRegistryFremiumListing;
